<template>
  <layout-content-vertical-nav :nav-menu-items="navMenuItems">
    <slot></slot>

    <!-- Slot: Navbar -->
    <template #navbar="{ isVerticalNavMenuActive, toggleVerticalNavMenuActive }">
      <div class="navbar-content-container" :class="{ 'expanded-search': shallShowFullSearch }">
        <!-- Left Content: Search -->
        <div class="d-flex align-center justify-space-between" style="flex: 1 1 0; min-width: 0">
          <router-link v-if="$vuetify.breakpoint.mdAndDown" to="/" class="d-flex flex-shrink-0 align-center">
            <img :src="require('@/assets/images/oo_logo.png')" alt="logo" height="50" class="app-logo" />
          </router-link>
          <!-- <app-bar-search
            :shall-show-full-search.sync="shallShowFullSearch"
            :data="appBarSearchData"
            :filter="searchFilterFunc"
            :search-query.sync="appBarSearchQuery"
            @update:shallShowFullSearch="handleShallShowFullSearchUpdate(isVerticalNavMenuActive, toggleVerticalNavMenuActive)"
          ></app-bar-search> -->
          <div class="d-flex align-center" style="flex: 1 1 0; min-width: 0">
            <v-sheet
              v-if="['30', '110'].includes(String(userData.profile)) && !$vuetify.breakpoint.xsOnly"
              class="flex-grow-1 ml-md-3 overflow-hidden rounded-pill"
              style="width: 100%; max-width: 800px; min-width: 0"
            >
              <customer-list v-if="['30', '110'].includes(String(userData.profile))" :style-theme="true" class="pl-0 pl-lg-6" />
            </v-sheet>
          </div>
        </div>

        <!-- Right Content: I18n, Light/Dark, Notification & User Dropdown -->
        <div class="d-flex align-center right-row">
          <app-bar-user-menu></app-bar-user-menu>
          <v-icon v-if="$vuetify.breakpoint.mdAndDown" class="ms-3" @click="toggleVerticalNavMenuActive">
            {{ icons.mdiMenu }}
          </v-icon>
        </div>
      </div>
    </template>

    <template #footer>
      <span class="footer-caption">
        © {{ new Date().getFullYear() }} Tüm Hakları Saklıdır. Crafted with ❤️ care by
        <a
          href="https://www.maverabilisim.com/bayi-portali-musteri-portali-b2b-portali/"
          target="_blank"
          rel="noopener noreferrer"
          class="text-primary"
          >Mavera</a
        >.
      </span>
    </template>
  </layout-content-vertical-nav>
</template>

<script>
// App Bar Components
import AppBarUserMenu from '@core/layouts/components/app-bar/AppBarUserMenu.vue'
import { mdiHeartOutline, mdiMenu } from '@mdi/js'
import themeConfig from '@themeConfig'

import { getVuetify } from '@core/utils'

// Search Data
import appBarSearchData from '@/assets/app-bar-search-data'
import { ref, watch } from '@vue/composition-api'

import LayoutContentVerticalNav from '@/@core/layouts/variants/content/vertical-nav/LayoutContentVerticalNav.vue'
import CustomerList from '@/components/CustomerList.vue'
import navMenuItems from '@/navigation/vertical'
import { getUserData } from '@/utils/userData'

export default {
  components: {
    LayoutContentVerticalNav,

    // App Bar Components
    AppBarUserMenu,
    CustomerList,
  },
  setup() {
    const $vuetify = getVuetify()
    const userData = getUserData()

    // Search
    const appBarSearchQuery = ref('')
    const shallShowFullSearch = ref(false)
    const maxItemsInGroup = 5
    const totalItemsInGroup = ref({
      pages: 0,
      files: 0,
      contacts: 0,
    })
    watch(appBarSearchQuery, () => {
      totalItemsInGroup.value = {
        pages: 0,
        files: 0,
        contacts: 0,
      }
    })
    const searchFilterFunc = (item, queryText, itemText) => {
      if (item.header || item.divider) return true

      const itemGroup = (() => {
        if (item.to !== undefined) return 'pages'
        if (item.size !== undefined) return 'files'
        if (item.email !== undefined) return 'contacts'

        return null
      })()

      const isMatched = itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1

      if (isMatched) {
        if (itemGroup === 'pages') totalItemsInGroup.value.pages += 1
        else if (itemGroup === 'files') totalItemsInGroup.value.files += 1
        else if (itemGroup === 'contacts') totalItemsInGroup.value.contacts += 1
      }

      return appBarSearchQuery.value && isMatched && totalItemsInGroup.value[itemGroup] <= maxItemsInGroup
    }

    // ? Handles case where in <lg vertical nav menu is open and search is triggered using hotkey then searchbox is hidden behind vertical nav menu overlaty
    const handleShallShowFullSearchUpdate = (isVerticalNavMenuActive, toggleVerticalNavMenuActive) => {
      if ($vuetify.breakpoint.mdAndDown && isVerticalNavMenuActive) {
        toggleVerticalNavMenuActive()
      }
    }

    return {
      navMenuItems,
      handleShallShowFullSearchUpdate,

      // App Config
      appName: themeConfig.app.name,
      appLogo: themeConfig.app.logo,

      // Search
      appBarSearchQuery,
      shallShowFullSearch,
      appBarSearchData,
      searchFilterFunc,
      userData,
      icons: {
        mdiMenu,
        mdiHeartOutline,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.navbar-content-container {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
  position: relative;
}

// ? Handle bg of autocomplete for blured appBar
.v-app-bar.bg-blur {
  .expanded-search {
    ::v-deep .app-bar-autocomplete-box div[role='combobox'] {
      background-color: transparent;
    }

    > .d-flex > button.v-icon {
      display: none;
    }

    // ===

    & > .right-row {
      visibility: hidden;
      opacity: 0;
    }

    ::v-deep .app-bar-search-toggler {
      visibility: hidden;
    }
  }
}

// Sağdaki menü/kullanıcı alanı, soldaki müşteri seçici genişlese bile ekran dışına itilmesin
.right-row {
  flex-shrink: 0;
}

.footer-caption {
  font-size: 0.6rem !important;
  line-height: 1.2;
}
</style>
